import React, { useCallback } from 'react';
import { twMerge } from 'tailwind-merge';

import { Assets } from '@assets';
import { SideBar } from '@components/sideBar/sideBar.component';
import { Text } from '@elements/text';
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { i18n } from '@i18n';
import { sendAnalyticsEvent } from '@utils';

type Props = {
  totalPrice: string;
};

export const CheckoutSummaryPopOver: React.FC<Props> = ({ totalPrice }) => {
  const handleSidebarExpanded = useCallback(() => {
    sendAnalyticsEvent('Traveller Details Payment Summary Expanded');
  }, []);

  return (
    <div className="sticky top-0 z-[9]">
      <Popover className="lg:hidden">
        {({ open }) => (
          <div
            className={twMerge(
              'relative',
              open && 'fixed top-0 bottom-0 h-full w-full bg-mono-100 z-40',
            )}>
            <PopoverButton
              className={twMerge(
                'flex items-center justify-between w-full bg-fuji-800 text-mono-100 px-6 py-5 lg:hidden border-6 border-white focus-visible:outline-none',
                !open && 'rounded-b-3xl',
              )}>
              <div className="flex items-center">
                <Text variant="body-16/r">{i18n.t('checkout.paymentUplift.title')}</Text>
                <Text variant="body-16/sb">
                  {i18n.t('checkout.paymentUplift.price', { amount: totalPrice?.replace('$', '') })}
                </Text>
              </div>
              {open ? (
                <Assets.ChevronUp className="h-6 w-6 text-mono-100" />
              ) : (
                <Assets.ChevronDown className="h-6 w-6 text-mono-100" />
              )}
            </PopoverButton>
            <PopoverPanel className="flex w-full h-[calc(100%_-_88px)] bg-mono-100">
              <div className="w-full overflow-y-auto">
                <div className="bg-fuji-800 px-1 h-screen">
                  <div className="w-full flex-auto rounded bg-mono-100 p-6 h-screen overflow-y-auto">
                    <SideBar onMount={handleSidebarExpanded} />
                  </div>
                </div>
              </div>
            </PopoverPanel>
            {open && (
              <div className={twMerge('fixed bottom-0 w-full')}>
                <div
                  className={twMerge(
                    ' justify-center items-center bg-fuji-800 text-mono-100 w-full flex',
                  )}>
                  <Assets.ChevronUp className="h-6 w-6 text-mono-100" />
                </div>
              </div>
            )}
          </div>
        )}
      </Popover>
    </div>
  );
};
